import { faArrowUpRightFromSquare, faBadgeCheck, faMegaphone, faCalendarAlt, faNewspaper, faCircleNotch, faChalkboardTeacher, faFont, faLightbulb, faBook, faComment, faBrowser, faCommentQuestion, faHeart, faBriefcase, faAlignJustify } from '@fortawesome/pro-solid-svg-icons';
import { faClock } from '@fortawesome/pro-light-svg-icons';
import { getThemeVarValue } from '../webUtils/theme';
import { TFunction } from 'i18next';

export type ContentType =
  | 'Announcement'
  | 'Blog'
  | 'Community'
  | 'Course'
  | 'CalendarEvent'
  | 'Glossary'
  | 'Ideation'
  | 'LibraryEntry'
  | 'MessagePost'
  | 'MessageThread'
  | 'Page'
  | 'Question'
  | 'Answer'
  | 'QAndA'
  | 'VolunteerOpportunity'
  | 'CalendarDate'
  | 'ExternalJob'
  | 'DocumentFile'
  | 'Document'
  | 'AutomatedResponseRef';

export const getIconForItemType = (type: string, t: TFunction, customDisplay?: string) => {
  let color;
  const display = type;
  switch (type) {
    case 'Announcement':
      return { icon: faMegaphone, color: '#61918D', display };
    case 'Blog':
      return { icon: faNewspaper, color: getThemeVarValue('blog-graphics'), display };
    case 'Community':
      return { icon: faCircleNotch, color: '#F58026', display };
    case 'Course':
      return {
        icon: faChalkboardTeacher,
        color: '#1F7CEF',
        display: t('common.courseWebinar', { defaultValue: 'Course/Webinar' })
      };
    case 'CalendarEvent':
      return {
        icon: faCalendarAlt,
        color: '#D0764F',
        display: t('common.event', { defaultValue: 'Event' })
      };
    case 'Glossary':
      return { icon: faFont, color: '#9D0F7E', display };
    case 'Ideation':
      return { icon: faLightbulb, color: '#EFBB56', display: t('common.idea', { defaultValue: 'Idea' }) };
    case 'LibraryEntry':
    case 'Document':
      return {
        icon: faBook,
        color: getThemeVarValue('library-graphics'),
        display: t('common.libraryEntry', { defaultValue: 'Library Entry' })
      };
    case 'MessagePost':
    case 'MessageThread':
      return {
        icon: faComment,
        color: getThemeVarValue('discussion-graphics'),
        display: t('common.discussion', { defaultValue: 'Discussion' })
      };
    case 'Page':
      return {
        icon: faBrowser,
        color: '#84CDA1',
        display: t('common.webPage', { defaultValue: 'Web Page' })
      };
    case 'Question':
    case 'Answer':
    case 'QAndA':
      return {
        icon: faCommentQuestion,
        color: getThemeVarValue('question-graphics'),
        display: t('common.question', { defaultValue: 'Question' })
      };
    case 'VolunteerOpportunity':
      return {
        icon: faHeart,
        color: '#CB3767',
        display: t('common.volunteerOpportunity', { defaultValue: 'Volunteer Opportunity' })
      };
    case 'CalendarDate':
      return { icon: faClock, color, display };
    case 'ExternalJob':
      return {
        icon: faBriefcase,
        color: '#61918D',
        display: t('common.jobOpportunity', { defaultValue: 'Job Opportunity' })
      };
    case 'AutomatedResponseRef':
      return {
        icon: faBadgeCheck,
        color: '#FFAE0D',
        display: t('common.officialAnswer', { defaultValue: 'Official Answer' })
      };
    default:
      // Check if it's a crawler type with a valid name
      if (type.toLowerCase().startsWith('crawl_') && customDisplay) {
        return {
          icon: faArrowUpRightFromSquare,
          color: '#5B79E7',
          display: customDisplay
        };
      }
      // Fall back to "Other"
      return {
        icon: faAlignJustify,
        color: '#C4C4C4',
        display: t('common.other', { defaultValue: 'Other' })
      };
  }
};
